import { yupResolver } from "@hookform/resolvers/yup";
import { Dialog, LinearProgress, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { StyledButton } from "../../../common/components/Button";
import { StyledLabel } from "../../../common/components/InputLabel";
import { DialogHeader } from "../styles";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { approveCaseDesign } from "../../../api/caseApi";

const ApproveDesignDialog = ({ caseId, open, onClose }) => {
  const [isSubmitting, setSubmitting] = useState(false);
  const { register, handleSubmit, reset } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        note: yup.string().nullable(),
      })
    ),
  });

  const handleApprove = async (values) => {
    setSubmitting(true);
    try {
      await approveCaseDesign({
        caseId,
        note: values.note,
      });
      reset();
      onClose();
    } catch (err) {
      console.log(err);
    }
    setSubmitting(false);
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      {isSubmitting && <LinearProgress />}
      <Box
        component="form"
        onSubmit={handleSubmit(handleApprove)}
        sx={{ paddingX: 3, paddingY: 2 }}
      >
        <DialogHeader>You want to approve this case?</DialogHeader>
        <Box sx={{ marginTop: 4 }}>
          <StyledLabel id="aapprove-note-label">Note</StyledLabel>
          <TextField
            aria-labelledby="approve-note-label"
            fullWidth
            multiline
            rows={4}
            FormHelperTextProps={{
              variant: "standard",
            }}
            disabled={isSubmitting}
            {...register("note")}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 4,
          }}
        >
          <StyledButton theme="green" type="submit" disabled={isSubmitting}>
            Yes
          </StyledButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ApproveDesignDialog;
